import CryptoJS from "crypto-js"

export default (context, inject) => {
    inject("md5", (str) => {
        return CryptoJS.MD5(str).toString()
    })
}